import axios from '../axiosInstances/axiosInstance';

export const updateAccount = (user) => {
  return axios.put(`/users/userInfo`, user);
};
